import React from 'react';
import './confirmation-modal.style.scss';
import { useTranslation } from 'react-i18next';

export interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirm and continue",
  cancelText = "No",
  loading = false
}) => {
  if (!isOpen) return null;
  const { t } = useTranslation();

  return (
    <div className="confirmation-modal-overlay">
      <div className="confirmation-modal ">
        <div className="confirmation-modal__header pb-3">
          <h3 className="confirmation-modal__title">{title}</h3>
          <button
            className="confirmation-modal__close mb-2 "
            onClick={onClose}
            type="button"
            disabled={loading}
          >
            ×
          </button>
        </div>

        <div className="confirmation-modal__body">
          <p className="confirmation-modal__message">{message}</p>
        </div>

        <div className="confirmation-modal__actions">
          {/* <button
            type="button"
            className="confirmation-modal__button confirmation-modal__button--secondary"
            onClick={onClose}
            disabled={loading}
          >
            {cancelText}
          </button> */}
          <button
            type="button"
            className="confirmation-modal__button confirmation-modal__button--primary"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner"></span>
                {t('PROCESSING') || 'Processing...'}
              </>
            ) : (
              confirmText
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
